import {
  PRE_MUTATE_CARD_NUMBER_REGXP,
  PRE_MUTATE_ZIP_CODE_REGXP,
} from '../../../constants/patterns';

const fieldToPatternMap = {
  cardNumber: PRE_MUTATE_CARD_NUMBER_REGXP,
  zipCode: PRE_MUTATE_ZIP_CODE_REGXP,
};

export default function paymentCardFormPremutations(formData, key, value) {
  const pattern = fieldToPatternMap[key];

  if (!pattern) {
    return true;
  }

  return pattern.test(value);
}
